import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ComponentType } from "@model";

@Injectable({ providedIn: "root" })
export class NotificationService {
  private _toShowComponent$ = new Subject<ComponentType | null>();
  toShowComponent$ = this._toShowComponent$.asObservable();

  showNotification(component: ComponentType): void {
    this._toShowComponent$.next(component);
  }

  closeNotification(): void {
    this._toShowComponent$.next(null);
  }
}
